import React, {   useEffect, useState } from "react";
import {   useLocation } from "react-router-dom";
import { Box,  Container,  Paper,  Toolbar } from "@mui/material";
import { ThemeProvider } from "@mui/material/styles";
import { useMediaQuery } from '@mui/material';
import PublicRoutes from "./PublicRoute";
import ProtectedRoutes from "./ProtectedRoute";
import Navbar from "../components/admin/SideNav/Navbar";
import { getTheme } from "../context/theme";
import { TimeProvider } from "../context/tmo";
import { useTheme } from '@mui/material/styles';
import ChatBot from "../pages/admin/chatbot";
import FloatingActions from "../components/admin/FloatingOption";
import AuthContext from "../context/AuthContext";
import ModalServerError from "../context/apiResponse/ModalServerError";
import SidebarDrawer from "../components/admin/SideNav/SidebarDrawer";

 
const MisRutas = ({ toggleTheme, themeMode }) => {
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [chatOpen, setChatOpen] = useState(false);
  const theme = useTheme();
  const location = useLocation();
  const noNavbarSidebarRoutes = ["/login", "/agente" ,"/gestionCobranza","/ucontact",'/gestionVenta'];
  const noNavbarSidebar = noNavbarSidebarRoutes.includes(location.pathname);
  const toggleDrawer = () => {
    setIsDrawerOpen(!isDrawerOpen);
  };
  const isDesktop = useMediaQuery(theme.breakpoints.up('sm'));

  useEffect(() => {
    // Abrir el cajón en dispositivos de escritorio
    if (isDesktop) {
      setIsDrawerOpen(true);
    }
  }, [isDesktop]);
  return (
    <>
      {!noNavbarSidebar && (
        <Box component="main" sx={{ background: '#f1f9f9', p: 5, [theme.breakpoints.down('sm')]: { p: 0 } }}>
          <ThemeProvider theme={getTheme(themeMode)}>
            <FloatingActions themeMode={themeMode} toggleTheme={toggleTheme} chatOpen={chatOpen} setChatOpen={setChatOpen} />
            {/*<ChatBot chatOpen={chatOpen} setChatOpen={setChatOpen} />*/}
            <SidebarDrawer isDrawerOpen={isDrawerOpen} />
            <Navbar handleMenuClick={toggleDrawer} />
            <Box sx={{
              transition: 'margin 0.4s',
              flexGrow: 1,
              padding: theme.spacing(6),
              [theme.breakpoints.down('sm')]: { marginLeft: 0, padding: theme.spacing(4) },

            }}>
              <ProtectedRoutes />
            </Box>
          </ThemeProvider>
        </Box>
      )}
        {noNavbarSidebar &&  
          <ThemeProvider theme={getTheme(themeMode)}>
          <TimeProvider>
            <Box 
                  sx={{ 
                    flexGrow: 1, 
                    p: 2,
                    background:'#f1f9f9',
                    [theme.breakpoints.down('sm')]: {
                        p: 1,
                    },
                  }}
            >
                <PublicRoutes />
            </Box>
        </TimeProvider>
        </ThemeProvider>
        }
    </>
  );
};

export default MisRutas;
